export function getKeyValueList (obj, includeKeys) {
  const keyValueList = Object.entries(obj)
    .map(([key, value]) => ({ key, value }))

  return includeKeys
    ? keyValueList.filter(({ key }) => includeKeys.includes(key))
    : keyValueList
}
